import { mb } from '../theme/mbTokens';

/** Text color used on dark fills. */
export const LIGHT_CONTRAST_COLOR = mb.surface;

export const getContrastColor = (backGroundColor?: string) => {
  // Default to white text for default blue background
  if (!backGroundColor) {
    return LIGHT_CONTRAST_COLOR;
  }

  const r = parseInt(backGroundColor.slice(1, 3), 16);
  const g = parseInt(backGroundColor.slice(3, 5), 16);
  const b = parseInt(backGroundColor.slice(5, 7), 16);

  // Calculate relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return black for light backgrounds, white for dark backgrounds
  return luminance > 0.5 ? mb.ink : LIGHT_CONTRAST_COLOR;
};
